/* istanbul ignore file */
import React, { useMemo, useRef } from 'react';
import { useFormContext } from 'framework/form';
import { QuickFiltersLayout } from 'framework/list';
import { Box } from '@mui/material';

const QuickFilters = ({ children }: { children: React.ReactElement[] }) => {
  const { data = {} } = useFormContext();
  const menuRef = useRef<HTMLDivElement>(null);
  const activeElement = menuRef?.current?.querySelector('.button-dropdown__menu-item:disabled');

  // Suppressed warnings because we should update value if form data were updated
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const value = useMemo(() => activeElement?.textContent || '', [activeElement, data]);

  return (
    <Box ref={menuRef} mb={1.5}>
      <QuickFiltersLayout displayedValue={value}>{children}</QuickFiltersLayout>
    </Box>
  );
};

export default QuickFilters;
